import { useMemo } from 'react';
import { useAuth } from 'react-oidc-context';

import { config } from '../../../config/config';
import {
    useComplianceChangedSubscription,
    useGetComplianceQuery,
} from '../graphql/compliance.graphql';

export function useComplianceChange() {
    const auth = useAuth();
    const profileId = auth.user?.profile.user_profile_id as string | undefined;

    const [{ data: initialData, fetching }] = useGetComplianceQuery({
        pause: !profileId,
        variables: {
            userProfileId: profileId as string,
            xTenantID: config.TENANT_ID,
        },
    });

    const [{ data }] = useComplianceChangedSubscription({
        pause: !profileId || fetching,
        variables: {
            userProfileId: profileId as string,
        },
    });

    const initialCompliance = initialData?.userProfile.compliance;
    const latestCompliance = data?.userProfileUpdated?.current?.compliance;
    const compliance = {
        ...(initialCompliance ?? {}),
        ...(latestCompliance ?? {}),
    };

    return useMemo(
        () => ({
            isDepositAllowed: compliance?.isDepositAllowed ?? true,
            isWithdrawAllowed: compliance?.isWithdrawAllowed ?? true,
            isWageringAllowed: compliance?.isWageringAllowed ?? true,
        }),
        [
            compliance?.isDepositAllowed,
            compliance?.isWageringAllowed,
            compliance?.isWithdrawAllowed,
        ],
    );
}
